/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const global = css`
  * {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    font-weight: 500;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    line-height: 1.5;
    text-decoration: none;
    box-sizing: border-box;
    list-style: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    font-size: 16px;

    @media (max-width: 768px) {
      font-size: 14px;
    }

    @media (max-width: 480px) {
      font-size: 13px;
    }
  }

  body {
    margin: 0;
    overflow-x: hidden;

    /* iOS Safari에서 100vh 문제 해결 */
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);

    /* 모바일에서 터치 스크롤 개선 */
    -webkit-overflow-scrolling: touch;

    /* 텍스트 선택 및 호출 방지 */
    -webkit-touch-callout: none;
    -webkit-text-size-adjust: 100%;

    /* 모바일에서 탭 하이라이트 제거 */
    -webkit-tap-highlight-color: transparent;
  }

  /* 이미지 반응형 처리 */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* 비디오 반응형 처리 */
  video {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* React Quill 에디터 반응형 개선 */
  .ql-editor {
    @media (max-width: 768px) {
      padding: 8px 12px;
      font-size: 14px;
    }

    @media (max-width: 480px) {
      padding: 6px 10px;
      font-size: 13px;
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: 4px;
      margin: 10px 0;
    }

    h1, h2, h3, h4, h5, h6 {
      margin: 15px 0 8px 0;

      @media (max-width: 768px) {
        margin: 12px 0 6px 0;
      }
    }

    ul, ol {
      padding-left: 20px;

      @media (max-width: 768px) {
        padding-left: 15px;
      }
    }
  }

  .ql-toolbar {
    @media (max-width: 768px) {
      border-radius: 4px 4px 0 0;
    }
  }

  .ql-container {
    @media (max-width: 768px) {
      border-radius: 0 0 4px 4px;
    }
  }

  /* 버튼 기본 스타일 */
  button {
    cursor: pointer;
    border: none;
    outline: none;
    transition: all 0.2s ease;

    &:focus {
      outline: 2px solid #3498db;
      outline-offset: 2px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  /* 입력 필드 반응형 개선 */
  input, textarea, select {
    width: 100%;
    font-family: inherit;

    @media (max-width: 768px) {
      font-size: 16px; /* iOS에서 줌 방지 */
    }
  }

  /* 스크롤바 스타일링 */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* 접근성 개선 */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  /* 고해상도 디스플레이 대응 */
  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    img {
      image-rendering: -webkit-optimize-contrast;
    }
  }
`;

export default global;
